











































import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      model: '',
      colour: '',
      wheels: '',
      thumbsUpSign: false,
      thumbsDownSign: false
    };
  },
  computed: {
    score(): string {
      return `${this.$store.state.score}/${this.$store.state.possibleScore}`;
    },
    gameOver(): boolean {
      return this.$store.state.gameOver;
    }
  },
  watch: {
    gameOver(isGameOver) {
      if (isGameOver) {
        (this.$refs['first-input'] as HTMLInputElement).blur();
        (this.$refs['second-input'] as HTMLInputElement).blur();
        (this.$refs['third-input'] as HTMLInputElement).blur();
        (this.$refs['ship-it-button'] as HTMLInputElement).blur();
        this.model = '';
        this.colour = '';
        this.wheels = '';
      }
    }
  },
  methods: {
    nextOrder() {
      this.$store.dispatch('nextOrder', {
        model: this.model,
        colour: this.colour,
        wheels: this.wheels
      }).then(success => {
        if (success) {
          this.thumbsUp();
        } else {
          this.thumbsDown();
        }
      });
      this.model = '';
      this.colour = '';
      this.wheels = '';
      const el: HTMLInputElement = this.$refs[
        'first-input'
      ] as HTMLInputElement;
      el.focus();
    },
    thumbsUp() {
      this.thumbsUpSign = true;
      setTimeout(() => {
        this.thumbsUpSign = false;
      }, 500);
    },
    thumbsDown() {
      this.thumbsDownSign = true;
      setTimeout(() => {
        this.thumbsDownSign = false;
      }, 500);
    }
  }
});
